import { atom } from 'jotai';
import dayjs from 'lib/dayjs';

export const nowAtom = atom<Date>(new Date(dayjs().format('YYYY-MM-DD HH:mm:ss')));

export default { nowAtom };
